<template>
  <div class="base-mit-data-table-crud-client">
      <v-data-table
        :headers="headers"
        :items="items"
        sort-by="calories"
        class="elevation-0"
        :items-per-page="pageSize"
        :page="page"
        :footer-props="pageSizes"
        :server-items-length="totalItems"
        :search="search.text"
        :mobile-breakpoint="-1"
        :hide-default-header="$vuetify.breakpoint.name === 'xs' && useMobileView()"
        :hide-default-footer="hideDefaultFooter"

        :show-select="showSelect"
        :single-select="singleSelect"

        :expanded.sync="expandedItems"
        :show-expand="showExpanded"
        :single-expand="singleExpanded"
        :item-key="itemKey"

        @pagination="updatePagination"
        @click:row="clickRow"
        @item-expanded="itemExpanded"
        @item-selected="itemSelected"
        @update:sort-by="sortByChanged"
        @update:sort-desc="sortDirectionChanged"
      >
        <!-- IMPORTANT - to expose the v-data-table dynamic slots through this component this is needed.
        it will iterate the slots and re-expose them here in this component, so anyone using it can use
        the same slots defined for v-data-table. -->
        <template v-for="field in Object.keys($scopedSlots)" v-slot:[field]="{item, isExpanded, expand}">
           <slot :name="field" :item="item" :search="search" :isExpanded="isExpanded" :expand="expand"/> <!--Added the search from this component into the slots exposed by v-data-table so consumers can see what current search is when creating templates -->
        </template>

        <!--
        Toolbar - Search
        -->
        <template v-slot:top>
            <v-toolbar v-if="showControlHeader" flat>
                <slot name="tableHeader" :title="title" :search="search">
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!-- SEARCH - disable search if totalItems is provided since this means we are using server side data-->
                    <v-text-field
                      v-if="totalItems === -1"
                      class="pr-5 doNotPrint"
                      v-model="search.text"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                </slot>

                <slot name="dialogEdit" v-bind:dialogProps="dialogEdit">
                  <v-dialog v-if="editable" v-model="dialogEdit.show" max-width="500px" persistent>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" class="mb-2 doNotPrint" v-bind="attrs" v-on="on">New {{itemTitle}}</v-btn>
                    </template>
                    <v-card>
                      <v-card-title><span class="text-h5">{{ formTitle }}</span></v-card-title>
                      <v-card-text>
                          <slot name="dialogContents" :item="dialogEdit.item" :dialogEdit="dialogEdit">
                            <v-container>
                              <v-row>
                                <v-col v-for="h in headers" :key="h.name" cols="12" sm="12" md="12">
                                  <v-text-field v-if="h.edit && typeof (h.edit.type) === 'undefined'" :value="updateByPath(dialogEdit.item, h.value)" @change="eventPropertyChange($event, dialogEdit.item, h.value)" :label="h.text"></v-text-field>
                                  <v-select v-if="h.edit && h.edit.type && h.edit.type ==='select-return-object'" :label="h.text" :items="h.edit.types.items" item-text="name" item-value="id" :value="updateByPath(dialogEdit.item, h.edit.path)" @change="eventPropertyChange($event, dialogEdit.item, h.edit.path)" return-object></v-select>
                                  <v-select v-if="h.edit && h.edit.type && h.edit.type ==='select'" :label="h.text" :items="h.edit.types.items" item-text="name" item-value="id" :value="updateByPath(dialogEdit.item, h.edit.path)" @change="eventPropertyChange($event, dialogEdit.item, h.edit.path)"></v-select>
                                </v-col>
                              </v-row>
                            </v-container>
                        </slot>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialogEdit.close">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="dialogEdit.save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </slot>
                <slot name="dialogDelete" v-bind:dialogProps="dialogDelete"></slot>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h7 grey lighten-2">
                        <v-icon color="amber" class="pr-3">mdi-alert</v-icon>Are you sure you want to delete this item?
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </slot>

          </v-toolbar>
        </template>

        <!--
        Mobile View - Header
        -->
        <template v-if="$vuetify.breakpoint.name === 'xs' && useMobileView()" v-slot:header="{ item, props }">
          <thead class="v-data-table-header">
            <tr>
              <th v-for="header in headers" :key="header.text" v-if="header.mobile" scope="col">
                {{ header.text }}
              </th>
              <th scope="col" v-if="showActions()">
                Actions
              </th>
            </tr>
          </thead>
        </template>
        <!--
        Mobile View - row
        -->
        <template v-if="$vuetify.breakpoint.name === 'xs'  && useMobileView()" v-slot:item="{ item }">
          <tr class="v-data-table__mobile-table-row v-data-table__expanded v-data-table__expanded__row">
              <td class="text-start" v-for="header in headers" :key="header.text" v-if="header.mobile" scope="col">

                <slot :name="'item.'+header.value+'-mobile'" :item="item" :search="search">
                  {{ updateByPath(item, header.value) }}
                </slot>
              </td>
              <td class="text-end" v-if="showActions()">
                <v-row>
                  <v-spacer/>
                  <v-btn class="pr-4" icon small @click="editItem(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                  <v-btn icon  small @click="deleteItem(item)"><v-icon>mdi-delete</v-icon></v-btn>
                </v-row>
              </td>
          </tr>
          <tr class="v-data-table__expanded v-data-table__expanded__content">
            <td colspan="3">
              <v-row>
                <v-col class="pl-8" cols="12">
                  <span v-if="typeof header.mobile === 'undefined'" v-for="header in headers" :key="header.text">
                    <slot :name="'item.'+header.value+'-mobile'" :item="item" :search="search">
                      <span>
                        {{header.text}}:
                      </span> {{ updateByPath(item, header.value) }}<br/>
                    </slot>
                  </span>
                </v-col>
              </v-row>
            </td>
          </tr>
        </template>

        <!--
        Desktop View - row
        -->
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data>
          <p>No data.</p>
        </template>
      </v-data-table>
  </div>
</template>

<script>

export default {
  name: 'BaseMitDataTableClient',
  components: {},
  props: {
    totalItems:{
      default: -1,
      type: Number
    },
    pageSizes:{
      default () {
        return {itemsPerPageOptions:[5, 10, 15, -1]};
      },
      type: Object
    },
    itemKey:{
      default () {
        return 'id';
      },
      type: String
    },
    showSelect:{
      default: false,
      type: Boolean
    },
    singleSelect:{
      default: true,
      type: Boolean
    },
    singleExpanded:{
      default: false,
      type: Boolean
    },
    showExpanded:{
      default: false,
      type: Boolean
    },
    showControlHeader:{
      default: true,
      type: Boolean
    },
    hideDefaultFooter:{
      default: false,
      type: Boolean
    },
    page:{
      default: 1,
      type: Number
    },
    pageSize:{
      default: -1,
      type: Number
    },
    title:{
      default: "Items",
      type: String
    },
    itemTitle: {
      default: "Item",
      type: String
    },
    headers: Array,
    items:Array,
    editable: {
      default: true,
      type: Boolean
    },
    getNewItem: {
      default: () => {},
      type: Function
    },
    getCopyItem: {
      default: () => {},
      type: Function
    },
    setCopyItem: {
      default: () => {},
      type: Function
    }
  },
  data: function() {
    return {
      //This needs to be an object so it can be passed to other components by reference
      //so that the value updates can be captured.
      search:{
        text:''
      },
      dialogDelete: false,
      expandedItems:[],
      dialogEdit:{ //slot object that can get passed to any slot override so that it has access to necessary data and functions
        show:false,
        item:this.getNewItem(),
        close:this.close,
        save:this.save,
        editedIndex: -1,
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.close()
    },
  },
  computed: {
      formTitle () {
        return this.dialogEdit.editedIndex === -1 ? 'New '+this.itemTitle : 'Edit '+this.itemTitle
      },
  },
  methods: {
      sortByChanged(prop){
          //just pass this through to anyone that cares
          this.$emit('update:sort-by',prop);
      },
      sortDirectionChanged(desc){
          //just pass this through to anyone that cares
          this.$emit('update:sort-desc',desc);
      },
      updatePagination (pagination) {
        //just pass this through to anyone that cares
        this.$emit('pagination',pagination);
      },
      clickRow (rowData){
        //just pass this through to anyone that cares
        this.$emit('click:row',rowData);
      },
      itemSelected(event){
        //just pass this through to anyone that cares
        // event:{
        //     item:(row item),
        //     value:boolean //if it is selected or not
        // }
        this.$emit('item-selected',event);
      },
      itemExpanded(event){
        //just pass this through to anyone that cares
        // event:{
        //     item:(row item),
        //     value:boolean //if it is expanded or not
        // }
        this.$emit('item-expanded',event);
      },
      useMobileView(){
        //If any header item has a .mobile property then we will use the mobile view
        for(let x = 0; x < this.headers.length; x++){
          if(this.headers[x].mobile){
            return true
          }
        }
        return false;
      },
      showActions(){
        //Only really needed in custom or mobile views as not including the actions in the header will not display it
        for(let x = 0; x < this.headers.length; x++){
          if(this.headers[x].value === 'actions'){
            return true
          }
        }
        return false;
      },
      //Update or just return the value of the target obj. Deep property get
      updateByPath(obj, path, val) {
        let parts = path.split(".");
        if (parts.length==1){
            if(val) return (obj[parts[0]] = val);
            else return obj[parts[0]];
        }
        return this.updateByPath(obj[parts[0]], parts.slice(1).join("."), val);
      },
      eventPropertyChange(event, item, propery){
        //update the property on the target item
        this.updateByPath(item, propery, event);
      },
      editItem (item) {
        this.dialogEdit.editedIndex = this.items.indexOf(item)

        this.dialogEdit.item = this.getCopyItem(item);

        this.$emit('edit-begin',this.dialogEdit.item);

        this.dialogEdit.show = true;//important to display the dialog after we set the getCopyItem from above to allow any down stream controls to get the data model.
      },
      deleteItem (item) {
        this.dialogEdit.editedIndex = this.items.indexOf(item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.$emit('delete',this.items.splice(this.dialogEdit.editedIndex, 1)[0]);
        this.close();
      },
      close () {
        //this.dialog = false;
        this.dialogEdit.show = false;

        this.dialogDelete = false;
        this.$nextTick(() => {
          this.dialogEdit.item = this.getNewItem();
          this.dialogEdit.editedIndex = -1;
        })
      },
      save () {
        //Editing
        if (this.dialogEdit.editedIndex > -1) {
          this.setCopyItem(this.items[this.dialogEdit.editedIndex], this.dialogEdit.item);
          this.$emit('edit',this.items[this.dialogEdit.editedIndex]);
        }
        //New
        else {
          this.items.push(this.dialogEdit.item)
          this.$emit('new',this.dialogEdit.item);
        }

        this.close()
      }
    }
}
</script>

<style lang="scss" scoped>
</style>
